import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import { useNavigation } from '@react-navigation/native'

import tw from '@/styles/tailwind'
import Text from '@/components/Text'
import IcomoonIcon from '@/components/IcomoonIcon'


export default function ProviderRow({ provider }: any) {
  const navigation = useNavigation()

  return (
    <TouchableOpacity
      style={tw`row items-center justify-between bg-white rounded-2xl border border-gray-100 mx-4 mb-4 px-4 py-3`}
      onPress={() => {
        (navigation as any).navigate("Vinte.Providers.Detail", { providerId: provider.uuid })
      }}
    >
      <View style={tw`flex-1 mr-2`}>
        <Text style={tw`text-gray-900 font-600`}>{provider.name}</Text>
        <Text style={tw`text-gray-400 text-sm mt-0.5`}>{provider.rfc}</Text>
      </View>

      <IcomoonIcon name='chevron-right' color={tw.color('gray-400')} />
    </TouchableOpacity>
  )
}
